import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { IgDialog, IgTypography } from "@intelligems/ig-theme";
import { useUnarchiveExperience } from "@src/api/experiences/unarchive-experience";
import { PERSONALIZATION_ROUTES } from "@src/routes/routes";
import { isDialogOpen, setDialog } from "@src/store/slices/global";

interface UnarchivePersonalizationDialogProps {
  experienceId: string | null | undefined;
  shouldNavigate?: boolean;
}

export const UnarchivePersonalizationDialog = ({
  experienceId,
  shouldNavigate = true,
}: UnarchivePersonalizationDialogProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isOpen = useSelector(isDialogOpen("unarchivePersonalization"));
  const unarchiveExperience = useUnarchiveExperience();

  const handleClose = () => {
    dispatch(setDialog({ dialog: "unarchivePersonalization", open: false }));
  };

  const handleUnarchive = () => {
    if (experienceId) {
      unarchiveExperience.mutate({
        body: undefined,
        pathParams: { experienceId: experienceId },
        queryParams: undefined,
      });

      dispatch(setDialog({ dialog: "unarchivePersonalization", open: false }));
      if (shouldNavigate) {
        void navigate(PERSONALIZATION_ROUTES.Personalizations, {
          state: {
            targetId: experienceId,
            expanded: true,
            archive: false,
            unarchive: true,
          },
        });
      }
    }
  };

  return (
    <IgDialog
      title={"Unarchive Experience?"}
      showDialog={isOpen}
      handleClose={handleClose}
      yesButtonText={"Unarchive"}
      handleYesClick={handleUnarchive}
      rawContent={
        <IgTypography component="div">
          Are you sure you want to unarchive this Experience?
          <ul>
            <li>It will remain inactive until you activate it</li>
            <li>You will be able to preview it</li>
            <li>You can archive it again at any point</li>
          </ul>
        </IgTypography>
      }
    />
  );
};
